import { validateText } from 'utils/helpers';
import { FormikErrors, useFormik } from 'formik';

import {
  requiredText,
  invalidFIOText,
  invalidUrlText,
  notOnlySpacesText,
  invalidSocialUrlText,
  invalidEmailFormatText,
  invalidPhoneNumberFormatText,
  fourRequiredDigitsText,
  requiredRussianText,
} from 'utils/constants';
import {
  validateFIO,
  validateUrl,
  validateEmail,
  validateSpaces,
  validateSocialUrl,
  validatePhoneNumber,
} from 'utils/helpers';

import * as C from './Form.const';
import * as T from './Form.types';

import { UserType } from 'graphql/types';

export const useBecomeSpeakerFormik = (
  user: UserType & { university?: string },
  step: number,
  onSubmit: () => void
) => {
  const userAddress = user?.address
    ? { ...user.address, __typename: undefined }
    : null;

  return useFormik({
    initialValues: {
      firstName: user?.firstName || '',
      lastName: user?.lastName || '',
      patronymic: user?.middleName || '',
      birthDate: user?.birthDate || null,
      region: userAddress,
      addressDetail: user?.addressDetail || '',
      activity: null,
      work: user?.workPlace || '',
      post: user?.position || '',
      regalia: user?.regalia || '',
      whichUniversity: user?.whichUniversityUserCome?.name || '',
      university: user?.university || '',
      graduationYear: user?.graduationYear || '',
      comment: '',
      performanceUrl: '',
      links: [''],
      fileCharter: [],
      fileLettersOfHonor: [],
      officialPhoto: [],
      phone: user?.phone || '',
      email: user?.email || '',
      isConsent: true,
      isEnrolledToLeagueOfLecturers: false,
      socials: [
        {
          name: 'vk',
          label: 'VK',
          link: user?.vkAccount || '',
        },
        {
          name: 'telegram',
          label: 'Telegram',
          link: user?.telegramAccount || '',
        },
      ],
      selectedCustomAddress: !!user?.addressDetail,
      selectedCustomUniversity: !!user?.university,
      hasFileCharterFilesError: false,
      hasFileLettersOfHonorFilesError: false,
    } as T.IBecomeSpeakerFormData,
    validate: (values: T.IBecomeSpeakerFormData) => {
      const errors: FormikErrors<T.IBecomeSpeakerFormData> = {};
      const socialsErrorsMap: any = {};

      if (step === 1) {
        if (!values.firstName) {
          errors.firstName = requiredText;
        } else if (!validateFIO(values.firstName)) {
          errors.firstName = invalidFIOText;
        }

        if (!values.lastName) {
          errors.lastName = requiredText;
        } else if (!validateFIO(values.lastName)) {
          errors.lastName = invalidFIOText;
        }

        if (!values.patronymic) {
          errors.patronymic = requiredText;
        } else if (!validateFIO(values.patronymic)) {
          errors.patronymic = invalidFIOText;
        }

        if (!values.birthDate) {
          errors.birthDate = requiredText;
        }
        if (values.selectedCustomAddress) {
          if (!values.addressDetail) {
            errors.addressDetail = requiredText;
          }
        } else {
          if (!values.region) {
            errors.region = requiredText;
          }
        }
      } else if (step === 2) {
        if (!values.activity) {
          errors.activity = requiredText;
        }
        if (!values.work) {
          errors.work = requiredText;
        } else if (!validateSpaces(values.work)) {
          errors.work = notOnlySpacesText;
        }
        if (!values.post) {
          errors.post = requiredText;
        } else if (!validateSpaces(values.post)) {
          errors.post = notOnlySpacesText;
        }
        if (!values.regalia) {
          errors.regalia = requiredText;
        } else if (!validateSpaces(values.regalia)) {
          errors.regalia = notOnlySpacesText;
        }
        if (values.selectedCustomUniversity) {
          if (!values.university) {
            errors.university = requiredText;
          } else if (values.university && !validateSpaces(values.university)) {
            errors.university = notOnlySpacesText;
          } else if (values.university && validateText(values.university)) {
            errors.university = requiredRussianText;
          }
        } else {
          if (!values.whichUniversity) {
            errors.whichUniversity = requiredText;
          }
        }
        if (!values.graduationYear) {
          errors.graduationYear = requiredText;
        } else if (
          values.graduationYear.length < 4 &&
          values.graduationYear.length > 0
        ) {
          errors.graduationYear = fourRequiredDigitsText;
        }
        if (values.fileCharter.length === 0) {
          errors.fileCharter = requiredText;
        }
        if (values.fileLettersOfHonor.length === 0) {
          errors.fileLettersOfHonor = requiredText;
        }
        if (!values.comment) {
          errors.comment = requiredText;
        } else if (!validateSpaces(values.comment)) {
          errors.comment = notOnlySpacesText;
        }
        if (!values.performanceUrl) {
          errors.performanceUrl = requiredText;
        } else if (
          values.performanceUrl &&
          !validateUrl(values.performanceUrl)
        ) {
          errors.performanceUrl = invalidUrlText;
        }
      } else if (step === 3) {
        if (!values.phone) {
          errors.phone = requiredText;
        } else if (!validatePhoneNumber(values.phone)) {
          errors.phone = invalidPhoneNumberFormatText;
        }
        if (!values.email) {
          errors.email = requiredText;
        } else if (!validateEmail(values.email)) {
          errors.email = invalidEmailFormatText;
        }

        values.socials.map((s) => {
          if (!validateSocialUrl(s.link)) {
            socialsErrorsMap[s.name] = invalidSocialUrlText;
          }
        });
        if (Object.keys(socialsErrorsMap).length > 0) {
          errors.socials = socialsErrorsMap;
        }
      }

      return errors;
    },
    onSubmit: onSubmit,
    enableReinitialize: true,
    initialStatus: C.FORMIK_STATUS.INITIALIZING,
  });
};
